import { Record, List } from 'immutable';
import { makeReducer, match } from 'web-app/util/redux';
import * as Actions from './actions';
export class ChildState extends Record({
    naps: List(),
    relations: List(),
    isFetching: false,
}) {
}
export default makeReducer([
    match(Actions.fetchChild, state => {
        return state.merge({
            isFetching: true,
        });
    }),
    match(Actions.fetchChildSuccess, (state, { payload }) => {
        return state.merge({
            isFetching: false,
            naps: List(payload.response.naps),
            relations: List(payload.response.relations),
        });
    }),
    match(Actions.fetchChildFailed, state => {
        return state.merge({
            isFetching: false,
        });
    }),
], new ChildState());
